import Typography from 'typography';

const typography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: 1.5,
  headerFontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol'
  ],
  bodyFontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol'
  ],
  overrideStyles: () => ({
    body: {
      backgroundColor: '#fafafa'
    },
    '.container': {
      display: 'block',
      width: '100%',
      maxWidth: '1000px',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: '1rem',
      paddingRight: '1rem'
    },
    '.heading': {
      fontSize: '1rem',
      color: '#666',
      textTransform: 'uppercase',
      letterSpacing: '1px'
    },
    '.lead': {
      fontSize: '1.5rem'
    },
    'a:hover': {
      color: '#cd4545'
    }
  })
});

typography.injectStyles();
